// extracted by mini-css-extract-plugin
export var divider = "_pl-0";
export var systemMessage = "_pl-1";
export var systemMessageWrapper = "_pl-2";